import { createReducer, PayloadAction, isAnyOf, combineReducers, Reducer } from "@reduxjs/toolkit";
import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";

import entryActionsChat from "../chat.entry-actions";

import archiveActions from "./archive.actions";

import { filterChatsByUpdateDate, handleAddRowInList, handleDeleteRowInListById } from "~/app/utils/helpers";

export interface ArchiveStore {
  isArchived: boolean;
  chatsArchivedList: ChatWithShortInfo[];
  isLoaded: boolean;
}

export const ArchiveReducer: Reducer<ArchiveStore> = combineReducers({
  isArchived: createReducer<boolean>(false, builder =>
    builder.addCase(
      archiveActions.handleSwitchToArchiveFolder,
      (_: boolean, { payload }: PayloadAction<boolean>) => payload
    )
  ),
  chatsArchivedList: createReducer<ChatWithShortInfo[]>([], builder =>
    builder
      .addCase(
        archiveActions.handleFetchArchiveChats,
        (_: ChatWithShortInfo[], { payload }: PayloadAction<ChatWithShortInfo[]>) => filterChatsByUpdateDate(payload)
      )
      .addMatcher(
        isAnyOf(entryActionsChat.handleCreateChat, entryActionsChat.handleUpdateChat),
        (chats: ChatWithShortInfo[], { payload }: PayloadAction<ChatWithShortInfo>) => {
          if (!payload.isArchived) {
            return handleDeleteRowInListById(chats, payload.id);
          }

          return filterChatsByUpdateDate(handleAddRowInList(chats, payload));
        }
      )
  ),
  isLoaded: createReducer<boolean>(false, builder =>
    builder
      .addCase(archiveActions.handleSwitchToArchiveFolder, (_, { payload }: PayloadAction<boolean>) => payload)
      .addCase(archiveActions.handleFetchArchiveChats, () => false)
      .addCase(archiveActions.handleFetchArchiveChatsFailed, () => false)
  )
});
